import { Stack, Tooltip } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import {
  formatAddress,
  formatName,
  formatPhoneNumber,
} from '../../../../../helpers/ordersUtiles'
import { getComp } from '../../../../../utils/utils/DI'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'

interface CustomerInfoContentProps {
  request: RequestType
}

const CustomerInfoContent: React.FC<CustomerInfoContentProps> = ({
  request,
}) => {
  const { getInstallationReasonName } = getComp('InstallationReasonStore')
  const { getStatusImage } = getComp('StatusesStore')
  const reasonName = getInstallationReasonName(request.reasonId)

  return (
    <Stack spacing={'16px'}>
      <DataUnit name={'Регион'} value={request.territory} />
      <DataUnit
        name={'Адрес'}
        value={
          <>
            {request.isDangerous && (
              <Tooltip title={'Проблемная зона'} placement='top'>
                <img
                  src={getImageSrc('isDangerous')}
                  alt=''
                  style={{
                    marginRight: '6px',
                    marginBottom: '-3px',
                    width: '16px',
                  }}
                />
              </Tooltip>
            )}
            {request.duplicateAddressConfirmed && (
              <Tooltip title={'Дубликат на адрес'} placement='top'>
                <img
                  src={getStatusImage(10)}
                  alt=''
                  style={{
                    width: '16px',
                    marginRight: '6px',
                    marginBottom: '-3px',
                  }}
                />
              </Tooltip>
            )}
            {formatAddress(request, false)}
          </>
        }
      />
      <DataUnit name={'Заказчик'} value={formatName(request)} />
      <DataUnit name={'Причина установки'} value={reasonName} />
      <DataUnit
        name={'Телефон'}
        value={request.phone ? formatPhoneNumber(request.phone, false) : '-'}
      />
      <DataUnit
        name={'Льготная категория'}
        value={request.preferentialCategory ?? '-'}
      />
      <DataUnit
        name={'Льготные категории'}
        value={getComp('CategoriesStore').formatCategory(
          request.categories ?? [],
        )}
      />
      <DataUnit
        name={'Дополнительная информация'}
        value={request.additionalInfo ?? '-'}
      />
    </Stack>
  )
}

export default observer(CustomerInfoContent)
